module.exports = __webpack_public_path__ + "static/media/Revit.5a83ff07.png";